import {ModuleIconInterface} from "../module-icon.interface";

export class SvgIcon {
    [key: string]: string | ModuleIconInterface
}

export const SVGICONTHEME: SvgIcon = {
    'accessibility': 'accessibility',
    'accessorize': 'accessorize',
    'admin-role': 'admin-role',
    'allTypes': 'toustypes',
    'apple': 'apple',
    'archive': 'archiver',
    'arrow_back': 'arrow_left',
    'arrow_diag': 'arrow_diag',
    'arrow_left': 'arrow_left',
    'arrow_left_circle_outline': 'arrow_left_circle_outline',
    'arrow_right': 'arrow_right',
    'arrow_right_circle_outline': 'arrow_right_circle_outline',
    'assignment_ind': 'assignment_ind',
    'avatar': 'avatar',
    'bookmark-added': 'bookmark_added',
    'brand': 'brand',
    'brand_menu': 'brand_menu',
    'brand_menu_large': 'brand_menu_large',
    'brand_square': 'brand-square',
    'brand_square_user-info': 'brand-square-user-info',
    'button-help__support': 'support',
    'check': 'check_rounded_700',
    'chevron-left-rounded-extra-light': 'chevron_left_rounded_extra_light',
    'class_add': 'add',
    'close': 'cross',
    'contact': 'contact',
    'corpus-card-listing__audio': 'play_arrow',
    'corpus-card-listing__bookmark': 'BookmarkBorder',
    'corpus-card-listing__bookmarkAdded': 'bookmark_added_24dp_E3E3E3_FILL1_wght400_GRAD0_opsz24',
    'corpus-card-listing__document': 'text_snippet',
    'corpus-card-listing__more': 'corpus_more_vert',
    'corpus-card-listing__text': 'corpus_text_snippet',
    'corpus-card-listing__url': 'corpus-link',
    'corpus-card-listing__video': 'play_arrow',
    'corpus-details__audio': 'corpus_play_circle_filled',
    'corpus-details__document': 'text_snippet',
    'corpus-details__fiche-section__list__button__icon': 'picture_as_pdf',
    'corpus-details__link': 'arrow_outward',
    'corpus-details__media-status--followed': 'folder_shared',
    'corpus-details__media-status--privacy': 'person_off',
    'corpus-details__options-actions__button--bookmarkAdded': 'bookmark_added',
    'corpus-details__options-actions__button--bookmarks': 'BookmarkBorder',
    'corpus-details__options-actions__button--share': 'folder_shared_outlined',
    'corpus-details__preview--fullscreen': 'open_in_full',
    'corpus-details__preview--play': 'play_arrow',
    'corpus-details__text': 'corpus_text_snippet',
    'corpus-details__thematics__link__icon': 'arrow_outward',
    'corpus-details__url': 'corpus-link',
    'corpus-details__video': 'corpus_play_circle_filled',
    'corpus-display__add': 'add',
    'corpus-display__controls__view-button--view-grid': 'grid_view',
    'corpus-display__controls__view-button--view-list': 'format_list_bulleted',
    'corpus-display__tune-rounded': 'tune_rounded',
    'corpus-simple-listing__audio': 'corpus_graphic_eq',
    'corpus-simple-listing__bookmark': 'BookmarkBorder',
    'corpus-simple-listing__bookmarkAdded': 'bookmark_added_24dp_E3E3E3_FILL1_wght400_GRAD0_opsz24',
    'corpus-simple-listing__document': 'text_snippet',
    'corpus-simple-listing__more': 'more_horiz',
    'corpus-simple-listing__text': 'corpus_text_snippet',
    'corpus-simple-listing__url': 'corpus-link',
    'corpus-simple-listing__videoUrl': 'corpus-link',
    'corpus-simple-listing__video': 'corpus_play_circle_filled',
    'credits': 'credits',
    'cross': 'cross',
    'cross_outline': 'cross_outline',
    'delete': 'trash',
    'document': 'document',
    'download-pdf': 'menu_book_fill',
    'drag_indicator': 'arrow_down_circle_outline',
    'duplicate': 'duplicate',
    'edit': 'edit',
    'editor-play': 'play_outline',
    'educ-role': 'educ-role',
    'educ-role-without-rec': 'educ-role-without-rec',
    'exit': 'exit',
    'facebook': 'facebook',
    'file': 'corpus',
    'file_download': 'menu_book_fill',
    'fill-in-blanks': 'remplir_blancs',
    'google': 'google',
    'group': 'group',
    'groups-form-add': 'check',
    'icon-arrow-back': 'arrow_back',
    'information': 'information',
    'institution_add': 'add',
    'join': 'join',
    'lessons': 'transition',
    'link': 'url',
    'lock': 'padlock',
    'mail': 'mail',
    'next': 'arrow_right_alt_rounded',
    'pdf': 'ressources',
    'play': 'play',
    'play-as-icon': 'play',
    'play-demo': 'sapiens_demo_play',
    'play-lesson': 'play_outline',
    'play-preview': 'visibility',
    'play-quiz': 'quiz_rounded',
    'plus': 'plus',
    'quit': 'logout_rounded_flipped_500',
    'retry': 'refresh_rounded_alt',
    'round-videoprojeter': 'round_videoprojeter',
    'round-videoprojeteroff': 'round_videoprojeteroff',
    'save': 'save',
    'shield': 'confi',
    'site_map': 'signpost',
    'step-done': 'step_done',
    'step-inprogress': 'step_inprogress',
    'step-pasfait': 'step_pasfait',
    'step_success': 'step_done',
    'student_add': 'check_circle_outline',
    'tooltip-info': 'info',
    'trainer_add': 'add',
    'transition': 'transition',
    'trash': 'trash',
    'unarchive': 'desarchiver',
    'unassign': 'unassign',
    'unlock': 'unlock',
    'user-menu': 'keyboard_arrow_down_rounded',
    'visibility': 'visibility',
    'visibility_cgurgpd': 'cgu',
    'visibility_legalnotice': 'visibility',
    'visibility_privacy': 'privacy',
    'warning': 'warning',
    'workgroup_add': 'add',
    'world': 'world',
    'xxx': 'dislike',
};